module.exports = __webpack_public_path__ + "static/media/poweredBy.e94d32ad.jpg";